import empty from './empty'

//возвращает variable или default
export default (variable,def)=>{
    return empty(variable)?def:variable;
}